import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AdminUser } from '@uw/core/models/admin-user.model';
import { AdminUserService } from '@uw/core/services/admin.user.service';
import { AuthService } from '@uw/core/services/auth.service';
import { Observable, of, mergeMap, tap, lastValueFrom } from 'rxjs';

/**
 * @deprecated Do not use this resolver as the login route is not being used in admin site anymore.
 *  The admin app uses the donor site login page. Routing to donor login page is handled in AuthGuard.
 */
@Injectable()
export class AuthPagesResolver  {

  constructor(
    protected router: Router,
    protected authService: AuthService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot,): Observable<any> | Promise<null> {

    let obs$;

    if ((route.queryParams && route.queryParams.access)) {

      // store the access token received as query param in localstorage
      // in order to provide value for authorization header for refresh-token api
      localStorage.setItem('token', route.queryParams.access);

      obs$ = this.authService.refreshToken(null).pipe(
        tap((token: any) => localStorage.setItem('token', token)),
        mergeMap((_) => this.authService.loadProfileWithPermission())
      );
    } else if (localStorage.getItem('token')) {
      // verify token
      obs$ = this.authService
        .loadProfileWithPermission();
    }

    if (obs$) {
      return lastValueFrom(obs$).then(
        (_ : any) => {
          this.router.navigate(['/private']);
          return null;
        }
      ).catch((error: any) => {
        localStorage.removeItem('token');
        return null;
      });
    } else {
      return of(null);
    }

    // let campaignId = route.paramMap.get("campaignId");
    // if (campaignId) {
    //   return this.campaignService.getCampaignDetail(campaignId).pipe(
    //     tap(campaign=> this.campaignStateService.setSelectedCampaign(campaign),
    //     catchError((_)=> {
    //       this.router.navigate([RoutesConst.CampaignList]); // todo: fined the landing page for WA user
    //       return of(null);
    //     })));
    // } else {
    //     this.router.navigate([RoutesConst.CampaignList]); // todo: fined the landing page for WA user
    //     return of(null);
    // }
  }
}
